import { render, staticRenderFns } from "./EvaluationToBeReviewed.vue?vue&type=template&id=b961c906&scoped=true"
import script from "./EvaluationToBeReviewed.vue?vue&type=script&lang=js"
export * from "./EvaluationToBeReviewed.vue?vue&type=script&lang=js"
import style0 from "./EvaluationToBeReviewed.vue?vue&type=style&index=0&id=b961c906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b961c906",
  null
  
)

export default component.exports